/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./fan.vue?vue&type=template&id=0a96bb15"
import script from "./fan.vue?vue&type=script&lang=js"
export * from "./fan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports